// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as LlIcon from "../components/LlIcon.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as WrappedSectionHeader from "./WrappedSectionHeader.bs.js";

function WrappedRivalCompanionStats(Props) {
  var topRivalCompanions = Props.topRivalCompanions;
  var botRivalCompanions = Props.botRivalCompanions;
  return React.createElement("div", {
              className: "pt-16"
            }, React.createElement(WrappedSectionHeader.make, {
                  title: "Rival Tacticians"
                }), React.createElement("div", {
                  className: "pb-2"
                }, "These are the tacticians you have been ", React.createElement("span", {
                      className: "font-medium text-primary-11"
                    }, "crushing"), " in your games:"), React.createElement("div", {
                  className: CssJs.style([
                        CssJs.display(CssJs.grid),
                        CssJs.gridAutoFlow(CssJs.column),
                        CssJs.gridTemplateColumns([
                              CssJs.px(100),
                              {
                                NAME: "repeat",
                                VAL: [
                                  {
                                    NAME: "num",
                                    VAL: 5
                                  },
                                  CssJs.px(100)
                                ]
                              }
                            ]),
                        CssJs.gridTemplateRows([{
                                NAME: "repeat",
                                VAL: [
                                  {
                                    NAME: "num",
                                    VAL: 3
                                  },
                                  CssJs.auto
                                ]
                              }]),
                        CssJs.alignItems(CssJs.center),
                        CssJs.unsafe("justifyItems", "center"),
                        CssJs.unsafe("boxShadow", "0 4px 2px -2px rgb(0 0 0 / 40%)")
                      ])
                }, React.createElement("div", undefined, "Opponent"), React.createElement("div", undefined, "Games"), React.createElement("div", {
                      className: "pb-1"
                    }, "Avg. Place"), Belt_Array.mapWithIndex(Belt_Array.slice(topRivalCompanions, 0, 5), (function (idx, param) {
                        var match = param[1];
                        var contentId = param[0];
                        return React.createElement(React.Fragment, {
                                    children: null,
                                    key: contentId
                                  }, React.createElement("div", {
                                        className: "w-full flex justify-center py-2" + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, React.createElement(LlIcon.make, {
                                            companionId: contentId,
                                            size: 68
                                          })), React.createElement("div", {
                                        className: "w-full text-center " + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, String(match[0])), React.createElement("div", {
                                        className: "w-full pb-1 text-center" + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, Global.toFixed(undefined, match[1])));
                      }))), React.createElement("div", {
                  className: "pt-8 pb-2"
                }, "These are some ", React.createElement("span", {
                      className: "font-medium text-primary-11"
                    }, "fearsome"), " tacticians you have been ", React.createElement("span", {
                      className: "font-medium text-primary-11"
                    }, "struggling"), " against the most:"), React.createElement("div", {
                  className: CssJs.style([
                        CssJs.display(CssJs.grid),
                        CssJs.gridAutoFlow(CssJs.column),
                        CssJs.gridTemplateColumns([
                              CssJs.px(100),
                              {
                                NAME: "repeat",
                                VAL: [
                                  {
                                    NAME: "num",
                                    VAL: 5
                                  },
                                  CssJs.px(100)
                                ]
                              }
                            ]),
                        CssJs.gridTemplateRows([{
                                NAME: "repeat",
                                VAL: [
                                  {
                                    NAME: "num",
                                    VAL: 3
                                  },
                                  CssJs.auto
                                ]
                              }]),
                        CssJs.alignItems(CssJs.center),
                        CssJs.unsafe("justifyItems", "center"),
                        CssJs.unsafe("boxShadow", "0 4px 2px -2px rgb(0 0 0 / 40%)")
                      ])
                }, React.createElement("div", undefined, "Opponent"), React.createElement("div", undefined, "Games"), React.createElement("div", {
                      className: "pb-1"
                    }, "Avg. Place"), Belt_Array.mapWithIndex(Belt_Array.slice(botRivalCompanions, 0, 5), (function (idx, param) {
                        var match = param[1];
                        var contentId = param[0];
                        return React.createElement(React.Fragment, {
                                    children: null,
                                    key: contentId
                                  }, React.createElement("div", {
                                        className: "w-full flex justify-center py-2" + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, React.createElement(LlIcon.make, {
                                            companionId: contentId,
                                            size: 68
                                          })), React.createElement("div", {
                                        className: "w-full text-center " + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, String(match[0])), React.createElement("div", {
                                        className: "w-full pb-1 text-center" + (
                                          idx % 2 === 0 ? " bg-bg2" : ""
                                        )
                                      }, Global.toFixed(undefined, match[1])));
                      }))));
}

var make = WrappedRivalCompanionStats;

export {
  make ,
  
}
/* CssJs Not a pure module */
